import { useRef } from 'react'
import { Text } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import Toast from 'react-native-root-toast'
import * as Sentry from '@sentry/react-native'
import { MessageType } from '../../../../utils/message-type'
import { MelddButton } from '../../../../@ui'
import {
  ConfirmDialogue,
  ConfirmDialogueRef,
} from '../../../../@ui/containers/modals/confirm.dialogue'
import { useCancelDowngradeMutation } from '../../../../generated/graphql'

interface CancelDowngradeButtonProps {
  nodeTierId: string
  onCancelSuccess?: () => void
}

export const CancelDowngradeButton = ({
  nodeTierId,
  onCancelSuccess,
}: CancelDowngradeButtonProps) => {
  const { t } = useTranslation('tiers')
  const confirmDialogRef = useRef<ConfirmDialogueRef>(null)
  const [cancelDowngrade, { loading }] = useCancelDowngradeMutation()

  const handleCancel = async () => {
    try {
      const result = await cancelDowngrade({
        variables: { id: nodeTierId },
      })

      if (result.data?.cancelDowngrade) {
        Toast.show(t('downgrade-cancelled'), MessageType.info)
        onCancelSuccess?.()
      }
    } catch (error) {
      console.error('Error cancelling downgrade:', error)
      Sentry.captureException(error)
      Toast.show(t('error-cancelling-downgrade'), MessageType.error)
      return false
    }
  }

  return (
    <>
      <MelddButton
        onPress={() => confirmDialogRef.current?.open()}
        title={t('cancel-downgrade')}
        isDisabled={loading}
      />
      <ConfirmDialogue
        ref={confirmDialogRef}
        label={t('cancel-downgrade-title')}
        onContinue={handleCancel}
        acceptLabel={t('cancel')}
        cancelLabel={t('keep')}
      >
        <Text>{t('cancel-downgrade-message')}</Text>
      </ConfirmDialogue>
    </>
  )
}
